import React from "react";
import TermsAndConditionsDetails from "./condition-details/TermsAndConditionsDetails";

const TermsAndConditions = () => {
  return (
    <div className="container-fluid conditions-fluid bg-common">
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-xl-9 col-lg-9 mx-auto">
            <TermsAndConditionsDetails/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
